import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Button, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

import { UserRole } from './components/UserRole';
import { UserCashRegister } from './components/UserCashRegister';

import { ROLE } from '../../../../constants';

export const UserOrganizationRole = ({
    index,
    access,
    existingAccess,
    existingCashRegisters,
    roles,
    cashRegistersSet,
    cashRegistersList,
    setAccess,
    setUserCashRegister,
    allowRemoving,
    editUser,
    handleAccessManage,
    handleCashRegisterAccess,
    handleOpenPopup,
    pageTitle,
    userId,
    userRoles
}) => {
    const { t } = useTranslation();
    const [readyToSaveRole, setReadyToSaveRole] = useState(true);
    const { role: currentRole } = access;
    const isCashier = currentRole === ROLE.cashier;

    useEffect(() => {
        setReadyToSaveRole(!(cashRegistersSet.length === 0 && isCashier));
    }, [cashRegistersSet, isCashier]);

    return (
        <Grid
            container
            item
            spacing={4}
            align='left'
            justifyContent={'left'}
            alignItems='flex-start'
        >
            <Grid item xs={editUser ? 4 : 5} marginBottom='auto'>
                <UserRole
                    key={currentRole + index}
                    role={currentRole || ''}
                    roles={roles}
                    disabled={existingAccess}
                    setAccess={role => {
                        setAccess(index, role);
                    }}
                />
            </Grid>
            <Grid item xs={editUser ? 4 : 5}>
                {isCashier && (
                    <UserCashRegister
                        role={currentRole || ''}
                        cashRegistersSet={cashRegistersSet || []}
                        cashRegistersList={cashRegistersList || []}
                        disabled={!existingCashRegisters && existingAccess}
                        setCashRegister={setUserCashRegister}
                        pageTitle={pageTitle}
                        userId={userId}
                        handleCashRegisterAccess={handleCashRegisterAccess}
                        userRoles={userRoles}
                    />
                )}
            </Grid>

            <Grid
                item
                xs={editUser ? 3 : 1}
                justifyContent='right'
                container
                alignItems='center'
            >
                {editUser && (
                    <Grid item xs={7} align='right'>
                        {(!existingAccess || !existingCashRegisters) && (
                            <Button
                                variant='outlined'
                                onClick={() => {
                                    handleAccessManage(index);
                                    handleCashRegisterAccess();
                                }}
                                disabled={!readyToSaveRole}
                            >
                                {t('save_role')}
                            </Button>
                        )}
                    </Grid>
                )}
                <Grid item xs={editUser ? 3 : 12} align='right'>
                    {allowRemoving && (
                        <IconButton
                            onClick={event => {
                                editUser && existingAccess
                                    ? handleOpenPopup(event, index)
                                    : setAccess(index);
                            }}
                            aria-label='delete'
                            size='small'
                            key={index}
                            aria-describedby='removePopup'
                            type='button'
                        >
                            <ClearIcon fontSize='inherit' />
                        </IconButton>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};
